import { SxProps, Theme, Link } from '@mui/material';
import { useDownloadQuotePdfFiles } from 'shared/mutations/pdf-download-mutation';
import { addPdfExtension } from 'shared/utility';
import { AdditionalQuoteDocumentationItem } from 'shared/types/quoteReview';
import { UseTableCellProps } from 'react-table';

const gridStyles: SxProps<Theme> = {
  display: 'grid',
};

export function QuoteDownloadFileColumn({
  value,
  row: {
    original: { id },
  },
}: UseTableCellProps<AdditionalQuoteDocumentationItem>) {
  const pdfDownloadMutation = useDownloadQuotePdfFiles();
  return (
    <Link
      sx={gridStyles}
      variant='body2'
      onClick={async () => {
        await pdfDownloadMutation.mutateAsync({
          fileId: !!id ? addPdfExtension(id) : '',
          originalFileName: value,
        });
      }}
    >
      {value}
    </Link>
  );
}
